import DownCaretThinIcon from "components/icons/DownCaretThinIcon";
import XIcon from "components/icons/XIcon";

export const CustomIndicatorsContainer = ({ selectProps, clearValue }) => {
  const shouldShowClearIcon = !selectProps.isRequired && selectProps.isClearable && selectProps.value;

  return (
    <div className='flex items-center'>
      {shouldShowClearIcon && (
        <div
          onTouchStart={selectProps.isDisabled ? undefined : clearValue}
          onClick={selectProps.isDisabled ? undefined : clearValue}
          className={`group px-2 ${selectProps.isDisabled ? 'cursor-not-allowed' : ''}`}
        >
          <XIcon
            className={`stroke-gray-1 ${!selectProps.isDisabled && 'group-hover:brightness-75'}`}
            size='sm'
          />
        </div>
      )}
      <DownCaretThinIcon
        size='lg'
        svgClassName={`transition-all ${selectProps.menuIsOpen && 'rotate-180'}`}
        pathClassName={`!stroke-gray-1  ${selectProps.menuIsOpen && '!stroke-primary'}`}
      />
    </div>
  );
};
